import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: center;
  margin: ${(props) => props.margin || '0 0 10px 0'};
  flex-wrap: ${(props) => props.wrap || 'wrap'};
`;
